var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1871 3.15576L22.771 6.97571C23.4107 7.50877 23.4107 8.49124 22.771 9.0243L18.1871 12.8442C17.3186 13.5679 16.0002 12.9504 16.0002 11.8199V9.33334C11.5819 9.33334 8.00016 12.9151 8.00016 17.3333C8.00016 21.7516 11.5819 25.3333 16.0002 25.3333C19.6222 25.3333 22.6853 22.9252 23.6691 19.6197C23.8791 18.9139 24.6215 18.512 25.3273 18.7221C26.0331 18.9321 26.435 19.6746 26.2249 20.3803C24.9139 24.7855 20.8342 28 16.0002 28C10.1091 28 5.3335 23.2244 5.3335 17.3333C5.3335 11.4423 10.1091 6.66667 16.0002 6.66667V4.18006C16.0002 3.04961 17.3186 2.43207 18.1871 3.15576Z",
    fill: "#9FB8C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.6d45915b9163ecf1851ed533a1b8e32c.svg";
export { ForwardRef as ReactComponent };